import React from "react";
import Films from "../../components/Films/Films";

const UpComing = () => {
  return <Films type="upcoming" />;
};

export default UpComing;
